export function getDocument(documentId, title, format) {
    return {
        type: 'REPORTING_GET_DOCUMENT',
        documentId,
        title,
        format
    };
}

export function error(errors) {
    return {
        type: 'REPORTING_ERROR_DOCUMENT',
        errors
    };
}

export function finish(format, title, documentBody) {
    const documentBlob = new Blob([documentBody], {
        type: documentBody.type
    });

    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(documentBlob);
        return;
    }

    const data = window.URL.createObjectURL(documentBlob);
    const link = document.createElement('a');

    link.href = data;
    link.download = `${title}.${format}`;
    document.body.appendChild( link );
    link.click();

    setTimeout( () => {
        URL.revokeObjectURL( data );
        document.body.removeChild( link );
    }, 0 );

    return {
        type: 'REPORTING_FINISH_DOCUMENT'
    };
}
